import { render } from "./FactoryReset.vue?vue&type=template&id=e7f2cecc"
import script from "./FactoryReset.vue?vue&type=script&lang=ts"
export * from "./FactoryReset.vue?vue&type=script&lang=ts"
script.render = render

export default script